import { IGetOfferParams, TGetOfferResult } from './types';
import { getOfferData } from '../getOfferData';
import { prepareOfferFromDraft } from '../prepareOfferFromDraft';

export async function getOffer(params: IGetOfferParams): Promise<TGetOfferResult> {
  const { httpApi, logger, realtyOfferId, draftGuid } = params;

  if (draftGuid) {
    const result = await prepareOfferFromDraft({ httpApi, logger, draftGuid });

    return result;
  }

  if (realtyOfferId) {
    const result = await getOfferData({ httpApi, realtyOfferId, logger });

    return result;
  }

  return null;
}
